import React, { useState, useEffect } from "react";

const links = ["About", "Projects", "Skills", "Writing", "Contact"];
const hrefs = ["#about", "#projects", "#skills", "#blog", "#contact"];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // close menu on resize to desktop
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 640) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <nav
      style={{
        ...s.nav,
        borderBottomColor: scrolled ? "var(--border)" : "transparent",
      }}
    >
      <div className="nav-inner" style={s.inner}>
        <a href="#hero" style={s.logo}>
          ~/rama
          {/* <span style={s.dot}>.</span> */}
          {/* dev */}
        </a>

        <ul className="nav-links-list" style={s.linksList}>
          {links.map((l, i) => (
            <li key={l} style={{ listStyle: "none" }}>
              <a href={hrefs[i]} style={s.link}>
                {l}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="mailto:ramakrishnakatragadda1729@gmail.com"
          className="nav-cta"
          style={s.cta}
        >
          Get in touch
        </a>

        <button
          className="nav-burger"
          style={s.burger}
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          <span
            style={{
              ...s.burgerLine,
              transform: open ? "rotate(45deg) translate(4px,4px)" : "none",
            }}
          />
          <span style={{ ...s.burgerLine, opacity: open ? 0 : 1 }} />
          <span
            style={{
              ...s.burgerLine,
              transform: open ? "rotate(-45deg) translate(4px,-4px)" : "none",
            }}
          />
        </button>
      </div>

      {open && (
        <div style={s.mobileMenu}>
          {links.map((l, i) => (
            <a
              key={l}
              href={hrefs[i]}
              style={s.mobileLink}
              onClick={() => setOpen(false)}
            >
              {l}
            </a>
          ))}
          <a
            href="mailto:ramakrishnakatragadda1729@gmail.com"
            style={{
              ...s.mobileLink,
              color: "var(--accent)",
              fontSize: "0.9rem",
            }}
          >
            Get in touch
          </a>
        </div>
      )}
    </nav>
  );
};

const s = {
  nav: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    background: "rgba(10,10,11,0.88)",
    backdropFilter: "blur(14px)",
    borderBottom: "1px solid transparent",
    transition: "border-color 0.3s",
  },
  inner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 60,
    maxWidth: 1200,
    margin: "0 auto",
  },
  logo: {
    fontFamily: "var(--mono)",
    fontSize: "0.82rem",
    color: "var(--accent)",
    textDecoration: "none",
    letterSpacing: "0.05em",
  },
  dot: { color: "var(--muted)" },
  linksList: { display: "flex", gap: "2rem", listStyle: "none" },
  link: {
    fontSize: "0.7rem",
    color: "var(--muted2)",
    textDecoration: "none",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
  },
  cta: {
    fontFamily: "var(--mono)",
    fontSize: "0.7rem",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "var(--accent)",
    border: "1px solid rgba(192,132,252,0.35)",
    padding: "6px 14px",
    borderRadius: "var(--radius)",
    textDecoration: "none",
  },
  burger: {
    display: "none",
    flexDirection: "column",
    gap: 5,
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 4,
  },
  burgerLine: {
    display: "block",
    width: 22,
    height: 1.5,
    background: "var(--muted2)",
    transition: "transform 0.2s, opacity 0.2s",
    borderRadius: 1,
  },
  mobileMenu: {
    position: "fixed",
    top: 60,
    left: 0,
    right: 0,
    bottom: 0,
    background: "var(--bg)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "2.5rem",
    zIndex: 999,
  },
  mobileLink: {
    fontSize: "1.3rem",
    color: "var(--text)",
    textDecoration: "none",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
  },
};

export default Nav;
